import { useState, useCallback } from "react";

export const useHover = (): {
  isHovered: boolean;
  handleMouseEnter: () => void;
  handleMouseLeave: () => void;
} => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setIsHovered(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsHovered(false);
  }, []);

  return { isHovered, handleMouseEnter, handleMouseLeave };
};
